import { SparklesIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedProviderCuratedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface ProviderCuratedEventProps {
  event: DiscriminatedProviderCuratedEvent;
}

export const ProviderCuratedEvent: React.FC<ProviderCuratedEventProps> = ({
  event,
}) => {
  const { provider } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-100">
          <SparklesIcon className="h-4 w-4 text-indigo-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityTitle>{provider.name}</ActivityTitle>
      <ActivityDescription>
        <div className="text-xs text-gray-500">
          Action: {event.payload.action}
        </div>
      </ActivityDescription>
    </ActivityBody>
  );

  const actions = event.payload.target_id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/treatment/${event.payload.target_id}`}
      >
        View Provider
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Provider Curated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
